import React, { Component } from 'react';
import Ec2PaTitle from './ec2PaTitle/ec2PaTitle.js';
import Ec2PaContent from './ec2PaContent/ec2PaContent.js';
import './ec2PatchErrors.css';

class Ec2PatchErrors extends Component {

    state = {

    };

    componentDidMount() {

    };

    render() {

      return (
        <div className="Ec2PatchErrorsPage">
          <Ec2PaTitle/>
          <Ec2PaContent/>
        </div>
      );

    };

};

export default Ec2PatchErrors;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PatchErrors.js